import { map, Observable, startWith } from 'rxjs';
import { takeRight } from 'lodash-es';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MediaService } from '@bp/shared/features/media';

import { TestimonialDto, TESTIMONIALS, VIDEO_TESTIMONIALS } from '@bp/promo/shared';

import { SEMI_FADE } from './animations';

@Component({
	selector: 'bp-testimonials',
	templateUrl: './testimonials.component.html',
	styleUrls: [ './testimonials.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [ SEMI_FADE ],
})
export class TestimonialsComponent {

	assetsDir = '/assets/home/testimonials/';

	videoTestimonial = VIDEO_TESTIMONIALS[0];

	testimonials = [
		TESTIMONIALS[2],
		TESTIMONIALS[5],
		TESTIMONIALS[3],
		TESTIMONIALS[0],
		TESTIMONIALS[1],
	];

	leftTextTestimonials$: Observable<TestimonialDto[]> = this.mediaService.currentBreakpointChange$.pipe(
		startWith(null),
		map(() => {
			if (this.mediaService.greaterThan('Tablet'))
				return this.testimonials.slice(0, 4);

			if (this.mediaService.greaterThan('PhoneLg'))
				return this.testimonials.slice(0, 3);

			return this.testimonials.slice(0, 1);
		}),
	);

	rightTextTestimonials$: Observable<TestimonialDto[]> = this.mediaService.currentBreakpointChange$.pipe(
		startWith(null),
		map(() => {
			if (this.mediaService.greaterThan('Tablet'))
				return takeRight(this.testimonials, 1);

			if (this.mediaService.greaterThan('PhoneLg'))
				return takeRight(this.testimonials, 2);

			return takeRight(this.testimonials, 4);
		}),
	);

	zaloraPreviewThumbnail$: Observable<string> = this.mediaService.currentBreakpointChange$.pipe(
		startWith(null),
		map(() => this.mediaService.greaterThan('Tablet') ? 'laptop' : 'tablet'),
		map(suffix => `${ this.assetsDir }zalora-preview-${ suffix }.png`),
	);

	constructor(public readonly mediaService: MediaService) {
	}

}
